import { createRules, FormRule } from "@hilma/netina2all";

export const generateOpeningDateSave = (isFriday: boolean, isSaturday: boolean) => {
    const timeRange: FormRule = { required: false, dateType: 'timeRange' };
    if (isFriday)
        timeRange['before'] = new Date(0, 0, 0, 16);
    else if (isSaturday)
        timeRange['after'] = new Date(0, 0, 0, 20);

    timeRange['minHourRange'] = 4;
    if (isSaturday) timeRange['minHourRange'] = 3;

    return createRules({
        option: { required: true },
        timeRange: { ...timeRange },
    })
};